import InquiryForm from '../InquiryForm';
import { navigation } from '../../../data/siteContent';

function HomeContactFooter() {
  return (
    <footer className="relative overflow-hidden bg-forest-950" id="kontakt">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_85%_15%,rgba(241,227,203,0.14),transparent_45%)]" />
      <div className="site-rail relative py-20 lg:py-28">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          <div>
            <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-sand-300">
              <span className="h-px w-8 bg-sand-300" />
              Kontakt
            </p>
            <h2 className="mt-5 font-serif text-[clamp(2.2rem,4.6vw,3.6rem)] font-bold leading-[1.05] text-cream-50 text-balance">
              Ta kontakt for tilgjengelighet og videre dialog.
            </h2>
            <p className="mt-6 max-w-[48ch] text-[1.08rem] leading-[1.75] text-cream-200/85">
              Send oss en henvendelse via skjemaet, så tar vi kontakt. Telefon og e-post legges til snart.
            </p>
            <nav aria-label="Bunnmeny" className="mt-10 flex flex-wrap gap-x-6 gap-y-2">
              {navigation.map((item) => (
                <a
                  className="text-sm font-semibold text-cream-200/80 no-underline transition hover:text-cream-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream-200 focus-visible:ring-offset-2 focus-visible:ring-offset-forest-950"
                  href={item.href}
                  key={item.href}
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
          <div className="rounded-[2rem] border border-white/10 bg-cream-100 p-7 shadow-lift md:p-9">
            <InquiryForm />
          </div>
        </div>
        <div className="mt-16 flex flex-col gap-2 border-t border-white/10 pt-8 text-sm text-cream-200/70 sm:flex-row sm:items-center sm:justify-between">
          <p className="m-0 font-semibold uppercase tracking-[0.16em] text-cream-100">
            OmsorgBygg<span className="text-sand-300">.no</span>
          </p>
          <p className="m-0">© {new Date().getFullYear()} OmsorgBygg.no — Boliger og bygg til leie i hele Norge.</p>
        </div>
      </div>
    </footer>
  );
}

export default HomeContactFooter;